import { render, staticRenderFns } from "./SalesDeliveryViewGlobal.vue?vue&type=template&id=7bb8c2be"
import script from "./SalesDeliveryViewGlobal.vue?vue&type=script&lang=js"
export * from "./SalesDeliveryViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports